/* eslint-disable no-restricted-syntax */
/* eslint-disable camelcase */
/* eslint-disable angular/document-service */
/* eslint-disable no-promise-executor-return */
/* eslint-disable angular/timeout-service */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import BarLoader from 'react-spinners/BarLoader';
import SyncLoader from 'react-spinners/SyncLoader';
import { FaRegCheckCircle, FaVideoSlash } from 'react-icons/fa';
import Modal from './Modal';
import ListsModal from '../ListsModal';

const VideoList = ({
    selectedVideo,
    personalVideos = [],
    libraryVideos,
    isLoaded,
    currentState,
    userId,
    deletePersonalVids = () => { },
    savePersonalVids = () => { },
    saveCurrentVideo = () => { },
    updateVideoStatus = () => { },
    setPersonalVideos = () => { },
    isMobile,
}) => {
    const [videoLists, setVideoLists] = useState();
    const [activeIndex, setActiveIndex] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [editableIndex, setEditableIndex] = useState(-1);
    const isSame = true;
    const [showModal, setShowModal] = useState(false);
    const [showDeleteAllModal, setShowDeleteAllModal] = useState(false);
    const [currentSelection, setCurrentSelection] = useState(null);
    const [deletedVideo, setDeletedVideo] = useState();
    const [deletedIndex, setDeletedIndex] = useState();
    const [videoMessage, setVideoMessage] = useState();
    const videoNameInput = document.getElementById('video-name');
    const customEmailMessageInput = document.getElementById(
        'custom-email-message',
    );
    const buttonLabelInput = document.getElementById('button-label');
    const buttonUrlInput = document.getElementById('button-url');
    const listItems = document.getElementById('video-list-item');
    const toggleDropAreaInput = document.getElementById('toggle-drop-area');
    const toggleModuleCtaInput = document.getElementById('toggle-module-cta');
    const toggleEmailEnabledInput = document.getElementById('toggle-module-email-cta');
    const currentSelectionRef = useRef(currentSelection);
    const currentPersonalVideo = useRef(personalVideos);
    const params = { personalVideoId: '' };
    const [disabled, setDisabled] = useState(isLoaded);
    const [libraryVideo, setLibraryVideos] = useState(libraryVideos);
    const [showListsModal, setShowListsModal] = useState(false);

    const handleVideoLists = () => {
        if (Array.isArray(personalVideos) && personalVideos.length > 0) {
            const videos_name = personalVideos.map((video) => video);
            setVideoLists(videos_name);
        }
    };

    useEffect(() => {
        if (selectedVideo !== null) {
            setCurrentSelection(selectedVideo);
        }
    }, [selectedVideo]);

    useEffect(() => {
        setDisabled(isLoaded);
    }, [isLoaded]);

    useEffect(() => {
        if (selectedVideo) {
            const {
                name,
                message,
                button_text,
                button_url,
                logo_enabled,
                button_enabled,
                show_in_email,
                id,
            } = selectedVideo;
            if (videoNameInput) {
                videoNameInput.value = name || '';
            }

            if (customEmailMessageInput) {
                customEmailMessageInput.value = message ?? '';
            }

            if (buttonLabelInput) {
                buttonLabelInput.value = button_text || '';
            }
            if (buttonUrlInput) {
                buttonUrlInput.value = button_url || '';
            }

            if (toggleDropAreaInput) {
                toggleDropAreaInput.checked = logo_enabled;
            }
            if (toggleModuleCtaInput) {
                toggleModuleCtaInput.checked = button_enabled;
            }
            if (toggleEmailEnabledInput) {
                toggleEmailEnabledInput.checked = show_in_email;
            }
            params.personalVideoId = id || '';
            handleVideoLists();
        }
    }, [selectedVideo]);

    useEffect(() => {
        currentSelectionRef.current = currentSelection;
    }, [currentSelection]);

    const handleFocus = () => {
        videoNameInput.focus();
        videoNameInput.select();
        videoNameInput.setSelectionRange(0, videoNameInput.value.length);
    };

    const handleToggleActive = (index, videoObject) => {
        setActiveIndex(index);
        updateVideoStatus('waiting');
        saveCurrentVideo(videoObject);
        setCurrentSelection(videoObject);
        if (!isMobile) {
            handleFocus();
        }
        const {
            name,
            message,
            button_text,
            button_url,
            logo_enabled,
            button_enabled,
            show_in_email,
        } = videoObject;

        if (videoNameInput) {
            videoNameInput.value = name;
        }
        if (customEmailMessageInput) {
            customEmailMessageInput.value = message !== null ? message : '';
        }
        if (buttonLabelInput) {
            buttonLabelInput.value = button_text !== null ? button_text : '';
        }
        if (buttonUrlInput) {
            buttonUrlInput.value = button_url !== null ? button_url : '';
        }
        if (toggleDropAreaInput) {
            toggleDropAreaInput.checked = logo_enabled !== null ? logo_enabled : true;
        }
        if (toggleModuleCtaInput) {
            toggleModuleCtaInput.checked = button_enabled !== null ? button_enabled : true;
        }
        if (toggleEmailEnabledInput) {
            toggleEmailEnabledInput.checked = show_in_email !== null ? show_in_email : true;
        }
    };

    useEffect(() => {
        if (personalVideos && personalVideos.length > 0) {
            setVideoLists(personalVideos);
            currentPersonalVideo.current = personalVideos;
            // to initiate the first thumbnail in case of waiting state
            if ((currentState === 'waiting' || !currentState)) {
                handleToggleActive(0, personalVideos[0]);
            } else {
                const selectedVideoIndex = personalVideos.findIndex((vid) => vid.selected);
                if (selectedVideoIndex !== -1) handleToggleActive(selectedVideoIndex, personalVideos[selectedVideoIndex]);
            }
        }
    }, [personalVideos]);

    useEffect(() => {
        setLibraryVideos(libraryVideos);
    }, [libraryVideos]);
    useEffect(() => {
        handleVideoLists();
    }, []);

    const addInputEventListeners = (elementIds, handler) => {
        elementIds.forEach((elementId) => {
            const element = document.getElementById(elementId);
            if (element) {
                element.addEventListener('change', handler);
            }
        });
    };

    const addChangeEventListener = (elementId, handler) => {
        const element = document.getElementById(elementId);
        if (element) {
            element.addEventListener('change', handler);
        }
    };

    const debounce = (func, delay) => {
        let timeoutId;
        return function (...args) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };
    const getValueIfExists = (elementId) => {
        const element = document.getElementById(elementId);
        return element ? element.value : '';
    };
    const getToggleIfExists = (elementId) => {
        const element = document.getElementById(elementId);
        return element ? element.checked : '';
    };
    const debouncedHandleInputChange = useRef(
        debounce(() => {
            const prevParams = {
                personalVideo: {
                    id: currentSelectionRef.current && currentSelectionRef.current.id,
                    name: selectedVideo && selectedVideo.name,
                    message: selectedVideo && selectedVideo.message,
                    button_text: selectedVideo && selectedVideo.button_text,
                    button_url: selectedVideo && selectedVideo.button_url,
                    button_enabled: selectedVideo && selectedVideo.button_enabled,
                    logo_enabled: selectedVideo && selectedVideo.logo_enabled,
                    show_in_email: selectedVideo && selectedVideo.show_in_email,
                },
            };

            const saveParams = {
                personalVideo: {
                    id: currentSelectionRef.current && currentSelectionRef.current.id,
                    name: getValueIfExists('video-name'),
                    message: getValueIfExists('custom-email-message'),
                    button_text: getValueIfExists('button-label'),
                    button_url: getValueIfExists('button-url'),
                    button_enabled: getToggleIfExists('toggle-module-cta'),
                    logo_enabled: getToggleIfExists('toggle-drop-area'),
                    show_in_email: getToggleIfExists('toggle-module-email-cta'),
                },
            };

            // Compare with previous values and update saveParams
            Object.keys(saveParams.personalVideo).forEach((key) => {
                if (key !== 'id') {
                    const currentValue = saveParams.personalVideo[key];
                    const previousValue = prevParams.personalVideo[key];

                    if (currentValue !== previousValue && currentValue !== '') {
                        // Only update if the value has changed and is not empty
                        prevParams.personalVideo[key] = currentValue;
                    } else {
                        // If the current value is empty or hasn't changed, remove it from saveParams
                        delete saveParams.personalVideo[key];
                    }
                }
            });

            savePersonalVids(saveParams);
        }, 500),
    ).current;

    useEffect(() => {
        const inputElementIds = [
            'video-name',
            'custom-email-message',
            'button-label',
            'button-url',
        ];
        const toggleElementIds = ['toggle-drop-area', 'toggle-module-cta', 'toggle-module-email-cta'];

        addInputEventListeners(inputElementIds, debouncedHandleInputChange);
        toggleElementIds.forEach((elementId) => {
            addChangeEventListener(elementId, debouncedHandleInputChange);
        });
        return () => {
            inputElementIds.forEach((elementId) => {
                const element = document.getElementById(elementId);
                if (element) {
                    element.removeEventListener('input', debouncedHandleInputChange);
                }
            });

            toggleElementIds.forEach((elementId) => {
                const element = document.getElementById(elementId);
                if (element) {
                    element.removeEventListener('change', debouncedHandleInputChange);
                }
            });
        };
    }, [
        selectedVideo,
        videoNameInput,
        customEmailMessageInput,
        buttonLabelInput,
        buttonUrlInput,
        toggleDropAreaInput,
        toggleModuleCtaInput,
        toggleEmailEnabledInput,
        listItems,
    ]);

    const openModal = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setShowDeleteAllModal(false);
    };

    useEffect(() => {
        if (personalVideos) {
            const videosName = personalVideos.map((video) => video);
            setVideoLists(videosName);
        }
    }, [personalVideos]);

    function handleLoaderClick() {
        setIsLoading(true);

        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    }

    const resetAll = () => {
        const resetValueIfExists = (elementId, value) => {
            const element = document.getElementById(elementId);
            if (element) {
                element.value = value;
            }
        };
        resetValueIfExists('custom-mobile-email-message', '');
        resetValueIfExists('video-name', '');
        resetValueIfExists('custom-email-message', '');
        resetValueIfExists('button-label', '');
        resetValueIfExists('button-url', '');

        ['toggle-drop-area', 'toggle-module-cta'].forEach((elementId) => {
            const element = document.getElementById(elementId);
            if (element) {
                element.checked = false;
            }
        });
    };

    const deleteAction = () => {
        let currentIndex;

        if (personalVideos.length <= 1 || deletedIndex === 0) {
            currentIndex = 0;
        } else {
            currentIndex = deletedIndex - 1;
        }
        // to delete from local storage
        deletePersonalVids(deletedVideo.id);
        setShowModal(false);
        const filtered = videoLists.filter((_, i) => i !== deletedIndex);
        setVideoLists(filtered);

        handleToggleActive(currentIndex, filtered ? filtered[currentIndex] : '');
        resetAll();
    };

    const scrollToBottom = (elementId) => {
        const element = document.getElementById(elementId);
        if (element) {
            element.scrollTo({ top: element.scrollHeight, behavior: 'smooth' });
        }
    };

    const handleAdd = (event) => {
        event.stopPropagation();
        event.preventDefault();
        savePersonalVids({ personalVideo: {} });
        setActiveIndex(personalVideos.length);
        setVideoLists(personalVideos);
        updateVideoStatus('waiting');
        resetAll();
        if (!isMobile) {
            if (videoNameInput) {
                videoNameInput.focus();
                videoNameInput.select();
                videoNameInput.setSelectionRange(0, videoNameInput.value.length);
            }
        }
        handleLoaderClick();
        setTimeout(() => scrollToBottom('user-item-list'), 1000);
    };

    const handleDelete = (event, index, videos) => {
        event.stopPropagation();
        event.preventDefault();
        openModal(true);
        setDeletedVideo(videos);
        setDeletedIndex(index);
    };
    useEffect(() => {
        let message = '';
        if (videoLists && videoLists.length > 0) {
            const videoCount = videoLists.length;
            if (videoCount === 1) {
                message = videoCount + ' Video';
            } else {
                message = videoCount + ' Videos';
            }
        } else {
            message = 'No videos in list.';
        }

        setVideoMessage(message);
    }, [personalVideos, videoLists, handleAdd, handleDelete]);

    const getBackgroundColor = (index) => {
        if (index === activeIndex) {
            return isSame ? '#3367F2' : 'green';
        }
        return isSame ? '#DDE1FD' : '#AFD9B5';
    };
    const getIcon = (videos, index) => {
        if (libraryVideo[videos.library_video_id]) {
            return (
                <FaRegCheckCircle
                    role="img"
                    aria-label="Video successfully added"
                    size='2em'
                    height='100%'
                    width='100%'
                    color={getBackgroundColor(index)}
                />
            );
        }

        return (
            <FaVideoSlash
                role="img"
                aria-label="No video added"
                size='2em'
                height='100%'
                width='100%'
                color={getBackgroundColor(index)}
            />
        );
    };
    const truncateText = (givenText, maxLength) => {
        if (givenText && givenText.length > maxLength) {
            var truncated = givenText.substring(0, maxLength) + '...';
            return truncated;
        }
        return givenText;
    };

    const handleToggleEdit = (index) => {
        setEditableIndex(index === editableIndex ? -1 : index);
    };
    const handleEdit = (index, updatedVideo) => {
        const { name, id } = updatedVideo;
        const updatedVideos = [...videoLists];
        updatedVideos[index] = updatedVideo;
        setVideoLists(updatedVideos);
        const editedVid = {
            personalVideo: {
                id: id,
                name: name,
            },
        };
        savePersonalVids(editedVid);
        saveCurrentVideo(updatedVideo);
    };

    const handleDeleteAll = () => {
        setShowDeleteAllModal(true);
        setShowModal(true);
    };

    const deleteAllAction = () => {
        setVideoLists([]);
        deletePersonalVids();
        closeModal();
    };

    const closeListModal = () => {
        setShowListsModal(false);
    };

    return (
        <div className='user-list-container'>
            <Modal
                id='example-modal-dialog'
                isOpened={showModal}
                onCloseDialog={closeModal}
                ctaClick={showDeleteAllModal ? deleteAllAction : deleteAction}
                isAllCheck={showDeleteAllModal}
            />
            <div style={{ textAlign: 'left' }}>{videoMessage}</div>
            <ul className='user-item-list' id='user-item-list'>
                {!disabled && videoLists ? (
                    videoLists.map((videos, index) => (
                        <div
                            key={index}
                            style={{ overflow: 'scroll' }}
                            className={`scroll-container ${index > 0 ? 'margin-t-8px' : ''}`}
                        >
                            <li
                                id='video-list-item'
                                key={videos.id}
                                style={{
                                    backgroundColor: getBackgroundColor(index),
                                    color: index === activeIndex ? 'white' : '#46464C',
                                    padding: '10px',
                                    fontSize: '16px',
                                    float: 'left',
                                    width: '88%',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    borderRadius: '3px',
                                }}
                                className={`user-input-${index === activeIndex ? 'active' : 'inactive'
                                }${isSame ? '' : '-past'} user-list-height no-overflow-input input-list`}
                                onClick={() => handleToggleActive(index, videos)}
                            >
                                {index === editableIndex && !isMobile && userId === videos.user_id ? (
                                    <input
                                        aria-required
                                        required
                                        className='user-text-center input-list'
                                        type='text'
                                        value={truncateText(videos.name, 20)} // Use the full value, not truncated
                                        onChange={(e) => handleEdit(index, { ...videos, name: e.target.value })
                                        }
                                        onBlur={() => handleToggleEdit(-1)} // Remove the focus from any item
                                        autoFocus
                                    />
                                ) : (
                                    <span
                                        className='user-text-center'
                                        onClick={() => handleToggleEdit(index)}
                                    >
                                        {truncateText(videos.name, 20)}
                                    </span>
                                )}
                                <button
                                    className='delete-button'
                                    onClick={(event) => handleDelete(event, index, videos)}
                                >
                                    <svg
                                        className={
                                            index === activeIndex
                                                ? 'active-white-close'
                                                : 'inactive-black-close'
                                        }
                                        xmlns='http://www.w3.org/2000/svg'
                                        viewBox='0 0 24 24'
                                    >
                                        <path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' />
                                        <path d='M0 0h24v24H0z' fill='none' />
                                    </svg>
                                </button>
                            </li>
                            <div
                                style={{
                                    float: 'right',
                                    width: '12%',
                                    position: 'relative',
                                }}
                            >
                                <div
                                    className='container-list-margin'
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginLeft: '2px',
                                        marginTop: '8px',
                                    }}
                                >
                                    {getIcon(videos, index)}
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <>
                        <div className='user-item-list'>
                            <div
                                style={{
                                    display: 'flex',
                                    overflowY: 'auto',
                                    height: '200px',
                                    maxHeight: '200px',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <SyncLoader color='#3367F2' height={20} />
                            </div>
                        </div>
                    </>
                )}
            </ul>
            {isSame ? (
                <button
                    type='button'
                    className='user-block block btn btn--ghost'
                    aria-labelledby='add-video-button'
                    onClick={(event) => handleAdd(event)}
                    disabled={disabled}
                    aria-label='Add Video'
                >
                    <span className='user-input-button'>
                        <i className='fa fa-plus fa-right' aria-hidden='true'></i>
                    </span>
                </button>

            ) : (
                <></>
            )}
            {isLoading && (
                <div className='user-item-list'>
                    <BarLoader height={10} width='auto' color='#3367F2' />
                </div>
            )}


            {
                personalVideos.length === 0 ? (
                    <div
                        onClick={() => setShowListsModal(true)}
                        style={{
                            marginTop: 8,
                            fontSize: 14,
                            textDecoration: 'underLine',
                            cursor: 'pointer',
                        }}>
                        Add from Contact List
                    </div>
                ) : (
                    <div
                        onClick={handleDeleteAll}
                        style={{
                            marginTop: 8,
                            fontSize: 14,
                            textDecoration: 'underLine',
                            cursor: 'pointer',
                        }}>
                        Clear All
                    </div>
                )
            }
            <ListsModal
                isOpened={showListsModal}
                onCloseListDialog={closeListModal}
                onAddFromLists={setPersonalVideos}
            />
        </div>
    );
};

VideoList.propTypes = {
    selectedVideo: PropTypes.object,
    personalVideos: PropTypes.array,
    libraryVideos: PropTypes.object,
    processing: PropTypes.object,
    isLoaded: PropTypes.bool,
    currentState: PropTypes.string,
    deletePersonalVids: PropTypes.func,
    savePersonalVids: PropTypes.func,
    saveCurrentVideo: PropTypes.func,
    updateVideoStatus: PropTypes.func,
    save: PropTypes.func,
    userId: PropTypes.number,
    isMobile: PropTypes.bool,
    setPersonalVideos: PropTypes.func,
};

export default VideoList;
